import { render, staticRenderFns } from "./BusinessCard.vue?vue&type=template&id=591b0b29&scoped=true"
import script from "./BusinessCard.vue?vue&type=script&lang=js"
export * from "./BusinessCard.vue?vue&type=script&lang=js"
import style0 from "./BusinessCard.vue?vue&type=style&index=0&id=591b0b29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591b0b29",
  null
  
)

export default component.exports